"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDispatcher = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var EventDispatcher = (function () {
    function EventDispatcher() {
        this.listeners = [];
    }
    EventDispatcher.prototype.clear = function () {
        list_1.ListUtils.clear(this.listeners);
    };
    EventDispatcher.prototype.add = function (listener) {
        if (!list_1.ListUtils.unsafeAnyOf(this.listeners, function (currListener) { return currListener === listener; }))
            this.listeners.push(listener);
    };
    EventDispatcher.prototype.remove = function (listener) {
        for (var i = 0, currListener = void 0; currListener = this.listeners[i]; i++) {
            if (currListener === listener) {
                this.listeners.splice(i, 1);
                break;
            }
        }
    };
    EventDispatcher.prototype.dispose = function () {
        var listeners = this.listeners;
        this.listeners = [];
        listeners.forEach(function (listener) { var _a; return (_a = listener.dispose) === null || _a === void 0 ? void 0 : _a.call(listener); });
    };
    return EventDispatcher;
}());
exports.EventDispatcher = EventDispatcher;
